import type { HeaderAssemblyEntityTable, HeaderAssemblyId } from "building-types/framing/headerAssemblyTypes";
import { LumberProfileType, LumberProfileTypeToName } from "building-types/framing/lumberTypes";
import { default2x10Id, default2x12Id, default2x4Id, default2x6Id, default2x8Id } from "./defaultLumberComponents";
import { headerAssemblyNewEntity } from "./headerAssembly";

function defaultHeaderAssemblyName(
  profileType: LumberProfileType,
  headerCount: number,
  isBracketStyle: boolean = true,
): string {
  if (isBracketStyle) {
    return `(${headerCount}) ${LumberProfileTypeToName[profileType]}`;
  }
  return `${headerCount}-${LumberProfileTypeToName[profileType]}`;
}

function defaultHeaderAssemblyId(profileType: LumberProfileType, headerCount: number): HeaderAssemblyId {
  return `HOUSE-HDR-AUTO-${LumberProfileTypeToName[profileType]}-${headerCount}`;
}

export const defaultSingleHeaderAssemblyId2x4 = defaultHeaderAssemblyId(LumberProfileType.SPF_2X4, 1);
export const defaultSingleHeaderAssemblyId2x6 = defaultHeaderAssemblyId(LumberProfileType.SPF_2X6, 1);
export const defaultSingleHeaderAssemblyId2x8 = defaultHeaderAssemblyId(LumberProfileType.SPF_2X8, 1);
export const defaultSingleHeaderAssemblyId2x10 = defaultHeaderAssemblyId(LumberProfileType.SPF_2X10, 1);
export const defaultSingleHeaderAssemblyId2x12 = defaultHeaderAssemblyId(LumberProfileType.SPF_2X12, 1);
export const defaultDoubleHeaderAssemblyId2x4 = defaultHeaderAssemblyId(LumberProfileType.SPF_2X4, 2);
export const defaultDoubleHeaderAssemblyId2x6 = defaultHeaderAssemblyId(LumberProfileType.SPF_2X6, 2);
export const defaultDoubleHeaderAssemblyId2x8 = defaultHeaderAssemblyId(LumberProfileType.SPF_2X8, 2);
export const defaultDoubleHeaderAssemblyId2x10 = defaultHeaderAssemblyId(LumberProfileType.SPF_2X10, 2);
export const defaultDoubleHeaderAssemblyId2x12 = defaultHeaderAssemblyId(LumberProfileType.SPF_2X12, 2);

const defaultHeaderAssembliesInternal = {
  [defaultSingleHeaderAssemblyId2x4]: headerAssemblyNewEntity(
    defaultHeaderAssemblyName(LumberProfileType.SPF_2X4, 1),
    1,
    default2x4Id,
    defaultSingleHeaderAssemblyId2x4,
  ),
  [defaultSingleHeaderAssemblyId2x6]: headerAssemblyNewEntity(
    defaultHeaderAssemblyName(LumberProfileType.SPF_2X6, 1),
    1,
    default2x6Id,
    defaultSingleHeaderAssemblyId2x6,
  ),
  [defaultSingleHeaderAssemblyId2x8]: headerAssemblyNewEntity(
    defaultHeaderAssemblyName(LumberProfileType.SPF_2X8, 1),
    1,
    default2x8Id,
    defaultSingleHeaderAssemblyId2x8,
  ),
  [defaultSingleHeaderAssemblyId2x10]: headerAssemblyNewEntity(
    defaultHeaderAssemblyName(LumberProfileType.SPF_2X10, 1),
    1,
    default2x10Id,
    defaultSingleHeaderAssemblyId2x10,
  ),
  [defaultSingleHeaderAssemblyId2x12]: headerAssemblyNewEntity(
    defaultHeaderAssemblyName(LumberProfileType.SPF_2X12, 1),
    1,
    default2x12Id,
    defaultSingleHeaderAssemblyId2x12,
  ),
  [defaultDoubleHeaderAssemblyId2x4]: headerAssemblyNewEntity(
    defaultHeaderAssemblyName(LumberProfileType.SPF_2X4, 2),
    2,
    default2x4Id,
    defaultDoubleHeaderAssemblyId2x4,
  ),
  [defaultDoubleHeaderAssemblyId2x6]: headerAssemblyNewEntity(
    defaultHeaderAssemblyName(LumberProfileType.SPF_2X6, 2),
    2,
    default2x6Id,
    defaultDoubleHeaderAssemblyId2x6,
  ),
  [defaultDoubleHeaderAssemblyId2x8]: headerAssemblyNewEntity(
    defaultHeaderAssemblyName(LumberProfileType.SPF_2X8, 2),
    2,
    default2x8Id,
    defaultDoubleHeaderAssemblyId2x8,
  ),
  [defaultDoubleHeaderAssemblyId2x10]: headerAssemblyNewEntity(
    defaultHeaderAssemblyName(LumberProfileType.SPF_2X10, 2),
    2,
    default2x10Id,
    defaultDoubleHeaderAssemblyId2x10,
  ),
  [defaultDoubleHeaderAssemblyId2x12]: headerAssemblyNewEntity(
    defaultHeaderAssemblyName(LumberProfileType.SPF_2X12, 2),
    2,
    default2x12Id,
    defaultDoubleHeaderAssemblyId2x12,
  ),
} as const;

export const builtInHeaderAssemblies: HeaderAssemblyEntityTable = defaultHeaderAssembliesInternal;

export const builtInHeaderAssembliesGroupId = "builtInHeaderAssembliesGroup";

export function isBuiltInHeaderAssembly(id: HeaderAssemblyId): boolean {
  return Object.keys(defaultHeaderAssembliesInternal).includes(id);
}
